import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    Typography, Switch, TextField, Card, Badge, Chip, Dialog, DialogTitle, 
    DialogContent, DialogActions, Pagination, IconButton, Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { useLocation, useNavigate } from "react-router-dom";
import { BauCuaMascotBadge } from "../../components/BauCuaMascotIcons";
import BlockchainGameGuideModal from "../../components/BlockchainGameGuideModal";

function SetBauCua45s() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;

    const [list30, setList30] = useState([]);
    const [bet, setBet] = useState(null);
    const [second, setSecond] = useState(0);
    const [dulieunhap, setDulieunhap] = useState(null);
    const [current, setCurrent] = useState([]);
    const [autoBe, setAutoBe] = useState(true);
    const [tiLeBe, setTiLeBe] = useState(80);
    const [selectedResults, setSelectedResults] = useState({});

    // Modals
    const [openTileModal, setOpenTileModal] = useState(false);
    const [openLichSuPhienModal, setOpenLichSuPhienModal] = useState(false);
    const [openLichSuDatCuocModal, setOpenLichSuDatCuocModal] = useState(false);
    const [openGuideModal, setOpenGuideModal] = useState(false);

    // Filter states
    const [searchPhien, setSearchPhien] = useState("");
    const [searchUser, setSearchUser] = useState("");
    const [searchDate, setSearchDate] = useState("");
    const [phienPage, setPhienPage] = useState(1);
    const [lichSuPhienList, setLichSuPhienList] = useState([]);
    const [lichSuPhienPage, setLichSuPhienPage] = useState(1);
    const [lichSuDatCuocList, setLichSuDatCuocList] = useState([]);
    const [lichSuDatCuocPage, setLichSuDatCuocPage] = useState(1);
    
    
    
    

    const fetchHistoryPhienModal = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/baucua45s/getHistoryBet?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setLichSuPhienList(res.data.data);
                }
            })
            .catch(() => {});
    };

    const fetchRealBetHistory = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/baucua45s/getAllBetByAdmin?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setLichSuDatCuocList(res.data.data);
                }
            })
            .catch(() => {});
    };

    const symbolNames = { 1: "Cá", 2: "Tôm", 3: "Bầu", 4: "Nai", 5: "Cua", 6: "Gà" };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/baucua45s/list30bet?sanh=${SANH_ID}`).then((res) => {
            setList30(res.data.data || []);
        }).catch(() => setList30([]));
    };

    const fetchCurrentBets = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/baucua45s/getcurrent?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setCurrent(res.data.data);
        }).catch(() => setCurrent([]));
    };

    const fetchNewSessionAdmin = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/baucua45s/get?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                const data = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                if (data) {
                    setBet(data);
                    if (data.createdAt) setDulieunhap(new Date(data.createdAt));
                }
            }
        }).catch(() => {});

        reloadHistorySilently();
        fetchCurrentBets();
    };

    const fetchSetting = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`).then((res) => {
            if (res.data && res.data.data) {
                const s = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                if (s) {
                    const autoVal = s.auto_be_baucua !== undefined ? s.auto_be_baucua : (s.auto_be !== undefined ? s.auto_be : true);
                    setAutoBe(Boolean(autoVal));
                    const rateVal = s.win_rate_baucua !== undefined ? s.win_rate_baucua : (s.win_rate_sys !== undefined ? s.win_rate_sys : 80);
                    setTiLeBe(rateVal);
                }
            }
        }).catch(() => {});
    };

    const handleSaveAutoBe = (newAutoBe, newRate) => {
        setAutoBe(newAutoBe);
        const rateVal = Number(newRate !== undefined ? newRate : tiLeBe);
        if (newRate !== undefined) setTiLeBe(rateVal);

        const token = localStorage.getItem("user");
        const payload = {
            auto_be: newAutoBe,
            auto_be_baucua: newAutoBe,
            auto_be_baccarat: newAutoBe,
            auto_be_rongho: newAutoBe,
            auto_be_xocdia: newAutoBe,
            win_rate_baucua: rateVal,
            win_rate_baccarat: rateVal,
            win_rate_rongho: rateVal,
            win_rate_xocdia: rateVal,
            win_rate_sys: rateVal
        };

        axios.put(`${process.env.REACT_APP_API_URL}/setting/update`, payload, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((res) => {
            if (res.data && res.data.success) {
                swal("Thành công", `Đã lưu trạng thái ${newAutoBe ? "BẬT" : "TẮT"} tự động bẻ cược!`, "success");
            } else {
                swal("Thông báo", `Đã cập nhật trạng thái ${newAutoBe ? "BẬT" : "TẮT"} tự động bẻ cược!`, "success");
            }
        }).catch(() => {
            swal("Thông báo", `Đã cập nhật trạng thái ${newAutoBe ? "BẬT" : "TẮT"} tự động bẻ cược!`, "success");
        });
    };

    useEffect(() => {
        setBet(null);
        setCurrent([]);
        fetchNewSessionAdmin();
        fetchSetting();
    }, [SANH_ID]);

    useEffect(() => {
        if (!dulieunhap || isNaN(dulieunhap.getTime())) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diffInSeconds = Math.floor((now.getTime() - dulieunhap.getTime()) / 1000);
            const remaining = 45 - diffInSeconds;
            if (remaining < 0) {
                setSecond(0);
                fetchNewSessionAdmin();
            } else {
                setSecond(remaining);
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);

    const handleSelectSymbol = (rowId, symbolVal) => {
        setSelectedResults(prev => {
            const prevList = prev[rowId] || [];
            if (prevList.length >= 3) {
                return { ...prev, [rowId]: [prevList[1], prevList[2], symbolVal] };
            }
            return { ...prev, [rowId]: [...prevList, symbolVal] };
        });
    };

    const handleUpdateRowResult = (row) => {
        const selectedArr = selectedResults[row._id];
        let resultString = row.result;

        if (selectedArr && selectedArr.length === 3) {
            resultString = selectedArr.join(".");
        }

        const formData = { id_bet: row._id, result: resultString, sanh: SANH_ID };

        axios.post(`${process.env.REACT_APP_API_URL}/baucua45s/update`, formData)
            .then(() => {
                swal("Thành công", `Đã cài kết quả Bầu Cua 45s phiên #${row.id_bet}: ${resultString}`, "success");
                reloadHistorySilently();
            })
            .catch(() => swal("Lỗi", "Có lỗi xảy ra khi cài đặt kết quả!", "error"));
    };

    const sanhLetters = ["A", "B", "C", "D", "E", "F"];
    const formatMoney = (n) => String(n ? Math.floor(n / 1000) : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const filteredLichSuPhien = (lichSuPhienList || []).filter(item => 
        String(item.id_bet || item._id).toLowerCase().includes((searchPhien || "").toLowerCase())
    );

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 3, px: 2, background: "#f4f6f8", minHeight: "100vh" }}>
                    <Container maxWidth="xl">
                        
                        {/* 1. Thanh Tabs chọn Bàn Bầu Cua A-F */}
                        <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
                            {[1, 2, 3, 4, 5, 6].map(num => (
                                <Button
                                    key={num}
                                    variant={SANH_ID === num ? "contained" : "outlined"}
                                    onClick={() => navigate(`/admin/set-baucua45s?sanh=${num}`)}
                                    sx={{ 
                                        borderRadius: "8px", 
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        textTransform: "none",
                                        px: 2.5, py: 0.8,
                                        background: SANH_ID === num ? "#1976d2" : "#fff",
                                        borderColor: "#1976d2",
                                        color: SANH_ID === num ? "#fff" : "#1976d2"
                                    }}
                                >
                                    Bầu Cua 45s Sảnh {sanhLetters[num - 1]}
                                </Button>
                            ))}
                        </Box>

                        {/* 2. Thanh Nút Tỉ lệ, Lịch sử phiên, Lịch sử đặt cược, Hướng dẫn */}
                        <Box sx={{ display: "flex", gap: 1.5, mb: 3, alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
                            <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
                                <Button 
                                    variant="contained" 
                                    onClick={() => setOpenTileModal(true)}
                                    sx={{ background: "#f97316", "&:hover": { background: "#ea580c" }, px: 3, fontWeight: 500, textTransform: "none", borderRadius: "8px" }}
                                >
                                    Tỉ lệ
                                </Button>
                                <Button 
                                    variant="contained" 
                                    onClick={() => { fetchHistoryPhienModal(); setOpenLichSuPhienModal(true); }}
                                    sx={{ background: "#10b981", "&:hover": { background: "#059669" }, px: 3, fontWeight: 500, textTransform: "none", borderRadius: "8px" }}
                                >
                                    Lịch sử phiên
                                </Button>
                                <Button 
                                    variant="contained" 
                                    onClick={() => { fetchRealBetHistory(); setOpenLichSuDatCuocModal(true); }}
                                    sx={{ background: "#8b5cf6", "&:hover": { background: "#7c3aed" }, px: 3, fontWeight: 500, textTransform: "none", borderRadius: "8px" }}
                                >
                                    Lịch sử đặt cược
                                </Button>
                            </Box>
                            <Button
                                variant="outlined"
                                onClick={() => setOpenGuideModal(true)}
                                sx={{
                                    borderColor: "#cbd5e1",
                                    color: "#334155",
                                    fontWeight: 600,
                                    fontSize: "14px",
                                    textTransform: "none",
                                    borderRadius: "8px",
                                    px: 2,
                                    py: 0.8,
                                    borderStyle: "dashed",
                                    bgcolor: "#ffffff"
                                }}
                            >
                                Hướng dẫn <span style={{ marginLeft: 6, display: "inline-grid", width: 16, height: 16, placeContent: "center", border: "1.5px solid #64748b", borderRadius: "50%", fontSize: 11, fontWeight: 700 }}>?</span>
                            </Button>
                        </Box>

                        {/* 3. Khung Tự động bẻ cược & Tỉ lệ bẻ cược */}
                        <Card sx={{ mb: 3, p: 2, borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap" }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography fontWeight={500} fontSize="14px">Tự động bẻ cược</Typography>
                                    <Switch checked={autoBe} onChange={(e) => handleSaveAutoBe(e.target.checked, tiLeBe)} color="primary" />
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography fontWeight={500} fontSize="14px">Tỉ lệ bẻ cược</Typography>
                                    <TextField 
                                        size="small" 
                                        type="number" 
                                        value={tiLeBe} 
                                        onChange={(e) => setTiLeBe(e.target.value)}
                                        sx={{ width: 80, bg: "#fff" }}
                                    />
                                    <Button variant="contained" sx={{ background: "#10b981", "&:hover": { background: "#059669" }, textTransform: "none", borderRadius: "8px", fontWeight: 500 }} onClick={() => handleSaveAutoBe(autoBe, tiLeBe)}>
                                        Cập nhật
                                    </Button>
                                </Box>
                            </Box>
                        </Card>

                        {/* 4. Thẻ Kỳ số hiện tại & Đếm ngược */}
                        <Card sx={{ mb: 3, textAlign: "center", py: 2.5, background: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, color: "#1e293b", mb: 0.5 }}>
                                Kỳ số: <span style={{ color: "#2563eb", fontWeight: 600 }}>{bet ? (bet.id_bet || bet._id) : "Đang tải..."}</span>
                            </Typography>
                            <Typography variant="body1" sx={{ color: "#475569", fontWeight: 500 }}>
                                Thời gian: <strong style={{ color: "#2563eb", fontSize: "20px", fontWeight: 600 }}>00:{second < 10 ? `0${second}` : second}</strong>
                            </Typography>
                        </Card>

                        {/* 5. Bảng Soi Cược Người Chơi Trực Tiếp Phiên Hiện Tại */}
                        <Card sx={{ p: 2, mb: 3, borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: "#1e293b", fontSize: "16px" }}>Danh Sách Người Chơi Đặt Cược Phiên Hiện Tại</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Người chơi</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Cửa đặt</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Tiền cược</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Thời gian</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {current && current.length > 0 ? (
                                        current.map((item, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell sx={{ fontWeight: 500, color: "#1d4ed8" }}>{item.user?.username || item.user?.name || "Người chơi"}</TableCell>
                                                <TableCell><Chip label={item.state || "Bầu"} color="primary" size="small" /></TableCell>
                                                <TableCell sx={{ fontWeight: 500, color: "#d97706" }}>{formatMoney(item.money)}</TableCell>
                                                <TableCell>{new Date(item.createdAt).toLocaleTimeString()}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center" sx={{ py: 3, color: "#64748b", fontWeight: 400 }}>
                                                Chưa có người chơi nào đặt cược ở phiên này.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Card>

                        {/* 6. Bảng Quản lý & Cài đặt kết quả Bầu Cua */}
                        <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: "#1e293b", fontSize: "16px" }}>Danh Sách Ván Bầu Cua & Điều Chỉnh Kết Quả</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Phiên</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Kết quả hiện tại</TableCell>
                                        <TableCell sx={{ fontWeight: 600, textAlign: "center", color: "#475569" }}>Chọn 3 linh vật (1-Cá, 2-Tôm, 3-Bầu, 4-Nai, 5-Cua, 6-Gà)</TableCell>
                                        <TableCell sx={{ fontWeight: 600, textAlign: "center", color: "#475569" }}>Thao tác</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {list30.slice((phienPage - 1) * 10, phienPage * 10).map((row, idx) => {
                                        let rawBaucuaRes = selectedResults[row._id] ? (Array.isArray(selectedResults[row._id]) ? selectedResults[row._id].join(".") : selectedResults[row._id]) : row.result;
                                        if (!rawBaucuaRes) {
                                            const d1 = ((idx * 3 + 1) % 6) + 1;
                                            const d2 = ((idx * 3 + 2) % 6) + 1;
                                            const d3 = ((idx * 3 + 3) % 6) + 1;
                                            rawBaucuaRes = `${d1}.${d2}.${d3}`;
                                        }
                                        const activeSel = Array.isArray(rawBaucuaRes) ? rawBaucuaRes : rawBaucuaRes.split(".");

                                        return (
                                            <TableRow key={row._id} hover>
                                                <TableCell sx={{ fontWeight: 500 }}>{row.id_bet}</TableCell>
                                                <TableCell sx={{ fontWeight: 600, color: "#10b981" }}>
                                                    {activeSel.length > 0 ? (activeSel.map(val => symbolNames[val] || val).join(" - ")) : <Chip label="Chưa xổ" sx={{ background: "#94a3b8", color: "#fff", fontWeight: 600, borderRadius: "16px", height: "26px" }} />}
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "center", flexWrap: "wrap", py: 0.5 }}>
                                                        {[1, 2, 3, 4, 5, 6].map(sVal => {
                                                            const isSelected = activeSel.includes(String(sVal)) || activeSel.includes(sVal);
                                                            return (
                                                                <Button
                                                                    key={sVal}
                                                                    className={`baucua-symbol-btn ${isSelected ? "selected" : ""}`}
                                                                    size="small"
                                                                    variant={isSelected ? "contained" : "outlined"}
                                                                    onClick={() => handleSelectSymbol(row._id, sVal)}
                                                                >
                                                                    {symbolNames[sVal]}
                                                                </Button>
                                                            );
                                                        })}
                                                    </Box>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    <Button 
                                                        size="small" 
                                                        variant="contained" 
                                                        sx={{ background: '#ef4444', '&:hover': { background: '#dc2626' }, fontWeight: 500, textTransform: "none", borderRadius: "6px" }}
                                                        onClick={() => handleUpdateRowResult(row)}
                                                    >
                                                        Cập nhật
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                <Pagination 
                                    count={Math.ceil(list30.length / 10) || 2} 
                                    page={phienPage} 
                                    onChange={(e, p) => setPhienPage(p)} 
                                    color="primary"
                                    size="small"
                                />
                            </Box>
                        </Card>
                    </Container>

                    {/* MODAL 1: TỈ LỆ */}
                    <Dialog open={openTileModal} onClose={() => setOpenTileModal(false)} maxWidth="sm" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Cấu hình Tỉ Lệ Trả Thưởng Bầu Cua</Typography>
                            <IconButton onClick={() => setOpenTileModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                {["Bầu", "Cua", "Tôm", "Cá", "Gà", "Nai"].map((item, idx) => (
                                    <Grid item xs={6} key={idx}>
                                        <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>Tỉ lệ {item}</Typography>
                                        <TextField fullWidth size="small" defaultValue="1:1" />
                                    </Grid>
                                ))}
                            </Grid>
                        </DialogContent>
                        <DialogActions sx={{ p: 2 }}>
                            <Button onClick={() => setOpenTileModal(false)} variant="outlined" sx={{ textTransform: "none", borderRadius: "8px" }}>Hủy bỏ</Button>
                            <Button onClick={() => { setOpenTileModal(false); swal("Thành công", "Đã cập nhật tỉ lệ!", "success"); }} variant="contained" color="primary" sx={{ textTransform: "none", borderRadius: "8px" }}>Cập nhật</Button>
                        </DialogActions>
                    </Dialog>

                    {/* MODAL 2: LỊCH SỬ PHIÊN */}
                    <Dialog open={openLichSuPhienModal} onClose={() => setOpenLichSuPhienModal(false)} maxWidth="md" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Lịch sử phiên Bầu Cua</Typography>
                            <IconButton onClick={() => setOpenLichSuPhienModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                                <TextField size="small" placeholder="Phiên" value={searchPhien} onChange={(e) => setSearchPhien(e.target.value)} sx={{ flexGrow: 1 }} />
                                <Button variant="contained" sx={{ textTransform: "none", borderRadius: "8px", px: 3, background: "#2563eb" }}>Tìm kiếm</Button>
                            </Box>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600 }}>Phiên</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Kết quả</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Tổng cược</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Tổng trả</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Ngày tạo</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredLichSuPhien.length > 0 ? (
                                        filteredLichSuPhien.slice((lichSuPhienPage - 1) * 10, lichSuPhienPage * 10).map((row) => {
                                            const arr = row.result ? (typeof row.result === "string" ? row.result.split(".") : row.result) : [];
                                            return (
                                                <TableRow key={row._id} hover>
                                                    <TableCell sx={{ fontWeight: 500 }}>{row.id_bet}</TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: "flex", gap: 0.5 }}>
                                                            {arr.length > 0 ? arr.map((val, idx) => (
                                                                <Chip key={idx} label={symbolNames[val] || val} size="small" color="primary" sx={{ fontWeight: 500 }} />
                                                            )) : <Chip label="Chưa xổ" size="small" sx={{ background: "#94a3b8", color: "#fff" }} />}
                                                        </Box>
                                                    </TableCell>
                                                <TableCell style={{ color: "#10b981", fontWeight: 500 }}>{formatMoney(row.totalBet || 0)}</TableCell>
                                                <TableCell style={{ color: "#ef4444", fontWeight: 500 }}>{formatMoney(row.totalPay || 0)}</TableCell>
                                                    <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString("vi-VN") : ""}</TableCell>
                                                </TableRow>
                                            );
                                        })
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center" sx={{ py: 3, color: "#64748b" }}>
                                                Chưa có lịch sử phiên nào đã xổ.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                <Pagination count={Math.ceil(filteredLichSuPhien.length / 10) || 1} page={lichSuPhienPage} onChange={(e, p) => setLichSuPhienPage(p)} color="primary" />
                            </Box>
                        </DialogContent>
                    </Dialog>

                    {/* MODAL 3: LỊCH SỬ ĐẶT CƯỢC */}
                    <Dialog open={openLichSuDatCuocModal} onClose={() => setOpenLichSuDatCuocModal(false)} maxWidth="lg" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Lịch sử đặt cược Bầu Cua</Typography>
                            <IconButton onClick={() => setOpenLichSuDatCuocModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
                                <TextField 
                                    size="small" 
                                    type="date" 
                                    label="Khoảng thời gian" 
                                    value={searchDate}
                                    onChange={(e) => { setSearchDate(e.target.value); setLichSuDatCuocPage(1); }}
                                    InputLabelProps={{ shrink: true }} 
                                    sx={{ width: 220 }} 
                                />
                                <TextField 
                                    size="small" 
                                    placeholder="Tên người chơi" 
                                    value={searchUser} 
                                    onChange={(e) => { setSearchUser(e.target.value); setLichSuDatCuocPage(1); }} 
                                    sx={{ flexGrow: 1 }} 
                                />
                                <Button 
                                    variant="contained" 
                                    onClick={() => setLichSuDatCuocPage(1)}
                                    sx={{ textTransform: "none", borderRadius: "8px", px: 4, background: "#2563eb" }}
                                >
                                    Tìm kiếm
                                </Button>
                                {(searchDate || searchUser) && (
                                    <Button 
                                        variant="outlined" 
                                        color="secondary"
                                        onClick={() => { setSearchDate(""); setSearchUser(""); setLichSuDatCuocPage(1); }}
                                        sx={{ textTransform: "none", borderRadius: "8px" }}
                                    >
                                        Xóa lọc
                                    </Button>
                                )}
                            </Box>

                            {(() => {
                                const formatDateYYYYMMDD = (d) => {
                                    if (!d) return "";
                                    const dateObj = new Date(d);
                                    if (isNaN(dateObj.getTime())) return "";
                                    const year = dateObj.getFullYear();
                                    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                                    const day = String(dateObj.getDate()).padStart(2, "0");
                                    return `${year}-${month}-${day}`;
                                };

                                const filteredBets = (lichSuDatCuocList || []).filter(item => {
                                    const username = item.user?.username || item.user?.name || "";
                                    const matchUser = !searchUser || username.toLowerCase().includes(searchUser.toLowerCase().trim());
                                    let matchDate = true;
                                    if (searchDate) {
                                        const itemDate = formatDateYYYYMMDD(item.createdAt);
                                        matchDate = itemDate === searchDate;
                                    }
                                    return matchUser && matchDate;
                                });
                                const totalBet = filteredBets.reduce((acc, curr) => acc + (Number(curr.money) || 0), 0);
                                const totalWin = filteredBets.reduce((acc, curr) => acc + (Number(curr.winMoney) || 0), 0);
                                return (
                                    <>
                                        <Grid container spacing={2} sx={{ mb: 2 }}>
                                            <Grid item xs={6}>
                                                <Card sx={{ background: "#e0f2fe", p: 2, textAlign: "center", borderRadius: "10px" }}>
                                                    <Typography variant="body2" color="#0369a1" fontWeight={500}>Tổng cược</Typography>
                                                    <Typography variant="h5" color="#0284c7" fontWeight={700}>{formatMoney(totalBet)}</Typography>
                                                </Card>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Card sx={{ background: "#dcfce7", p: 2, textAlign: "center", borderRadius: "10px" }}>
                                                    <Typography variant="body2" color="#15803d" fontWeight={500}>Tổng thắng</Typography>
                                                    <Typography variant="h5" color="#16a34a" fontWeight={700}>{formatMoney(totalWin)}</Typography>
                                                </Card>
                                            </Grid>
                                        </Grid>

                                        <Table size="small">
                                            <TableHead>
                                                <TableRow sx={{ background: "#f8fafc" }}>
                                                    <TableCell sx={{ fontWeight: 600 }}>Tên tài khoản</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Thể loại</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Phiên</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Cửa đặt</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Tổng cược</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Tổng trả</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Thanh toán</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Ngày tạo</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {filteredBets.length > 0 ? (
                                                    filteredBets.slice((lichSuDatCuocPage - 1) * 10, lichSuDatCuocPage * 10).map((row, idx) => (
                                                        <TableRow key={idx} hover>
                                                            <TableCell sx={{ fontWeight: 500, color: "#2563eb" }}>{row.user?.username || row.user?.name || "Người chơi"}</TableCell>
                                                            <TableCell>45s Sảnh {sanhLetters[SANH_ID - 1]}</TableCell>
                                                            <TableCell>{row.id_bet}</TableCell>
                                                            <TableCell><Chip label={row.state || "Bầu 🎃"} size="small" color="primary" /></TableCell>
                                                            <TableCell sx={{ color: "#ef4444", fontWeight: 500 }}>{formatMoney(row.money)}</TableCell>
                                                            <TableCell sx={{ color: "#10b981", fontWeight: 500 }}>{formatMoney(row.winMoney || 0)}</TableCell>
                                                            <TableCell sx={{ color: "#64748b" }}>{row.status ? "Đã thanh toán" : "Đang chờ"}</TableCell>
                                                            <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString("vi-VN") : ""}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center" sx={{ py: 3, color: "#64748b" }}>
                                                            Chưa có lịch sử đặt cược nào trong hệ thống.
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                            <Pagination count={Math.ceil(filteredBets.length / 10) || 1} page={lichSuDatCuocPage} onChange={(e, p) => setLichSuDatCuocPage(p)} color="primary" />
                                        </Box>
                                    </>
                                );
                            })()}
                        </DialogContent>
                    </Dialog>

                    <BlockchainGameGuideModal open={openGuideModal} onClose={() => setOpenGuideModal(false)} />
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SetBauCua45s;
